import { render, staticRenderFns } from "./CakeFlavourPicker.vue?vue&type=template&id=196f47bb&"
import script from "./CakeFlavourPicker.vue?vue&type=script&lang=js&"
export * from "./CakeFlavourPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports